<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Assesment Type Subject Avg Calculation
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense class="no-display">
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        @click="putnull()"
                        @change="getStd()"
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        persistent-hint
                        hint="Please select academic year"
                    />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Select Standard"
                        outlined
                        @change="getDiv"
                        @click="putnull"
                        persistent-hint
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Select Division" outlined @click="putnull" persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        @click="putnull()"
                        v-model="sem"
                        return-object
                        :items="semester_list"
                        item-text="sem"
                        label="Select Semester"
                        outlined
                        persistent-hint
                        hint="Please select semester"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        @click="putnull()"
                        v-model="assessment_type"
                        item-value="id"
                        :items="assessment_detail_list"
                        item-text="assessmenttype"
                        label="Select Assessment Type"
                        outlined
                        persistent-hint
                        hint="Please Select Assessment Type"
                    />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="sel_ay_data && div && sel_std_data && sem && assessment_type">
                    <v-btn class="mt-6 button" @click="onload()">Fetch / Generate</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''">
                <v-data-table :headers="headers" @current-items="getFiltered" :items-per-page="25" :items="bookList1" dense sort-by="" class="elevation-1 mytable" :search="search" item-key="id">
                    <template v-slot:top class="pb-5">
                        <v-row justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete
                                                        class="mr-2 pb-5 pt-2"
                                                        flat
                                                        hide-details
                                                        small
                                                        rounded
                                                        dense
                                                        outlined
                                                        color="#0F2027"
                                                        :label="header.text"
                                                        multiple
                                                        clearable
                                                        :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"
                                                    ></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
                <center>
                    <v-btn rounded class="button mt-6" v-if="learner_info != ''" @click="saveCalc()">Save / Update</v-btn>
                </center>
            </v-col>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                snackbar_msg: "",
                color: "",
                snackbar: false,
                overlay: false,
                search: null,
                installment_details: [],
                dialog: false,
                std_id: null,
                ay_std_div_list: null,
                sel_ay_data: null,
                ay_id: null,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                section_list: null,
                section: null,
                show: false,
                semester_list: [],
                sem: null,
                assessment_detail_list: [],
                assessment_type: null,
                role: null,
                learner_info: [],
                headers: [
                    { text: "Sr. No.", value: "sr_no" },
                    { text: "Registration No.", value: "reg_no" },
                    { text: "Name", value: "name" },
                    { text: "Standard", value: "standard" },
                    { text: "Division", value: "div" },
                    { text: "Already Saved Percentage", value: "present_percentage" },
                    { text: "Total Marks", value: "totalmarks" },
                    { text: "Obtained Marks", value: "obtained_marks" },
                    { text: "Updated Percentage", value: "percentage_converted" },
                ],
                filterArr: [],
                filters: {
                    reg_no: [],
                    standard: [],
                    div: [],
                    name: [],
                },
            };
        },
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        computed: {
            bookList1() {
                return this.learner_info.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.learner_info.map((d) => d[val]);
            },
            putnull() {
                this.show = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            async saveCalc(){
                const data = {
                    asd: this.assessment_type,
                    ay: this.sel_ay_data.ay_id,
                    learner_info: this.learner_info,
                    sem: this.sem.id,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Examination/saveAssTypeAvgCalc", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Save successfully");
                        this.onload()
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            },
            async onload() {
                this.role = localStorage.getItem("para_role");
                let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    asd: this.assessment_type,
                    std: this.sel_std_data.std_id,
                    sem: this.sem.id,
                    div: div,
                    role: this.role,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/Examination/getAssTypeAvgCalc", data);
                    if (res.data.flag == "YES") {
                        this.learner_info = res.data.learner_info;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    console.log("bye...");
                    this.overlay = false;
                }
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
            main() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.section_list = res.data.section_list;
                        this.semester_list = res.data.semester_list;
                        this.assessment_detail_list = res.data.assessment_detail_list;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
        },
        mounted() {
            this.main();
        },
    };
</script>
<style scoped>
   
</style>
